import { BASE_URL, ERROR_CODES, API_GATEWAY_KEY } from "./Constants";
import Cookies from "js-cookie";

export const fetchErrorCodes = async () => {
  let response = await fetch(`${BASE_URL}${ERROR_CODES}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};
